import * as qs from 'query-string';
import isEmpty from 'lodash/isEmpty';
import {VEHICLE_NUMBER_KEY, ON_DEMAND_FILTER_KEY, REDIRECT_KEY} from '../../app/historyUtil';
import OAuth2PKCE from '../../Helper/OAuth2PKCE';
const OAuthHelper = new OAuth2PKCE();

class LoginAuth {
  handleRedirection(state) {
    const params = qs.parse(state);
    const systemId = params.ref;

    if (systemId) {
      localStorage.setItem('systemId', systemId);
    } else {
      localStorage.removeItem('systemId');
    }
    
    // redirect user to where it was before being redirected to the login page
    const newParams = qs.parse(window.location.search);
    if (newParams.code) {
      delete newParams.code;
      delete newParams.data_region;
      delete newParams.state;
    }
    
    if (params[VEHICLE_NUMBER_KEY]) {
      newParams[VEHICLE_NUMBER_KEY] = params[VEHICLE_NUMBER_KEY];
    }

    if (params[ON_DEMAND_FILTER_KEY]) {
      newParams[ON_DEMAND_FILTER_KEY] = params[ON_DEMAND_FILTER_KEY];
    }

    if (params[REDIRECT_KEY]) {
      const urlVal = decodeURIComponent(params[REDIRECT_KEY]);
      const paramSeparator =  urlVal && urlVal.indexOf("?") !== -1 ? "&" : "?";
      window.location = `${urlVal}${!isEmpty(newParams) && newParams.length > 0  ? `${paramSeparator}${qs.stringify(newParams)}` : ''}`;
    } else if (newParams[VEHICLE_NUMBER_KEY] || newParams[ON_DEMAND_FILTER_KEY]) {
      window.location.search = qs.stringify(newParams);
    }
  }

  isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  hasAccessToken() {
    return OAuthHelper.hasAccessToken();
  }

  async handleRefreshToken() {
    return await OAuthHelper.getAccessTokenWithRefreshToken();
  }

  hasStateForRedirect() {
    const params = new URLSearchParams(OAuthHelper.stateParam);
    params.delete('fromUrl');

    if (params.size > 0) {
      return true;
    }

    return false;
  }

  getStateForRedirect() {
    const params = new URLSearchParams(OAuthHelper.stateParam);
    params.delete('fromUrl');

    return params.toString();
  }

  async handleAuthentication(onLogin) {
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get('code');
    if (!this.isAuthenticated() && !authCode) {
      OAuthHelper.handleLogin();
    } else if (!this.isAuthenticated() && authCode) {
      const tokens = await OAuthHelper.getAccessToken(authCode);
      OAuthHelper.saveTokens(tokens);

      const prevURL = urlParams.get('state');
      if (prevURL) {
        this.handleRedirection(prevURL);
        onLogin(tokens);
      } else {
        window.location.href = '/'
      }      
    }
  }

  logout() {
    OAuthHelper.clear();
    OAuthHelper.handleLogout();
  }
}

export default new LoginAuth();
